import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const base = (process.env.PUBLIC_URL || '').replace(/\/$/, ''); // '' or '/frontend'
const i18nVersion =
  (typeof window !== 'undefined' && window.APP_CONFIG?.i18nVersion) || '4';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'fr'],
    load: 'languageOnly',
    ns: ['landing'],
    defaultNS: 'landing',
    backend: {
      // works at '/', '/frontend', or any subpath
      loadPath: `${base}/locales/{{lng}}/{{ns}}.json?v=${i18nVersion}`
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage'],
    },
    debug: false,
  });

// quick diagnostics (remove later)
i18n.on('failedLoading', (lng, ns, msg) => console.warn('i18n failedLoading', { lng, ns, msg }));
export default i18n;
